<template>
  <div
    v-if="isDesktop"
    class="sidebar"
  >
  <navigation-menu @on-navigate="navigate($event)"/>
  </div>
  <ion-menu
    v-if="!isDesktop"
    class="side-menu"
    content-id="main-content"
    menu-id="app-menu"
  >
    <navigation-menu @on-navigate="navigate($event)"/>
  </ion-menu>
  <div class="navigation-menu" v-if="!isDesktop">
    <ion-menu-toggle
      class="holder-btn"
    >
      <ion-button
        @click="toggleMenu"
        fill="clear"
        class="navigation-menu__navigation-btn"
        :class="{'active': isMenuOpen }"
      >
        <ion-icon slot="icon-only" src="assets/icon/menu.svg"/>
      </ion-button>
    </ion-menu-toggle>
    <div
      class="holder-btn"
      v-for="item in appNav"
      :key="item.name"
      @click="navigate(item.isMainButton ? checkRoute(item) : item)"
    >
      <ion-button
        fill="clear"
        class="navigation-menu__navigation-btn"
        :class="{
          'navigation-menu__navigation-btn--main': item.isMainButton,
          'active': route?.path?.includes(item?.url),
        }"
      >
        <ion-icon slot="icon-only" :src="item.icon" />
      </ion-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IonButton, IonIcon, IonMenuToggle, IonMenu, menuController } from '@ionic/vue';
import { computed, onMounted, ref } from 'vue';
import { appNav } from '@/const/navigation';
import {useBreakpoint } from '@/hooks/useBreakpoint'
import NavigationMenu from '@/modules/General/components/NavigationMenu.vue'
import router from '@/router';
import { MenuItem } from '@/interfaces/MenuItem';
import { MenuButton } from '@/interfaces/MenuButton';
import { isMobile } from '@/helpers/isMobile';
import { isAbleToDo } from '@/helpers/isAbleToDo';
import { ProfileSettingsEnum } from '@/gql/graphql';
import { NavigationItem } from '@/interfaces/NavigationItem';
import { useUserStore } from '../store/userStore';
import { useRoute } from 'vue-router';

const user = computed(() => useUserStore()?.user);
const route = useRoute();

const checkRoute = (item: NavigationItem) => isAbleToDo(user.value, ProfileSettingsEnum.PostWork) ? item : '';

const { isDesktop } = useBreakpoint();

const isMenuOpen = ref<boolean>(false);

const toggleMenu = () => {
  menuController.toggle('app-menu')
  isMenuOpen.value = !isMenuOpen.value
}

const navigate = (item: MenuItem | MenuButton | NavigationItem) => {
  if(item?.route) {
    if(!item?.disabled) {
      menuController.close('app-menu').then(() =>{
        router.push({name: item?.route})
      })
    }
  } else {
    menuController.close('app-menu').then(() =>{
      router.push({
        name: item?.name,
        params: { id : item?.id },
        query: item?.query
      });
    })
  }
}

if(isMobile.value && window.history.state.back === '/login' && (user.value?.team?.is_active_subscriber || user.value?.is_impersonated)) {
  setTimeout(async () => {
    if(await menuController.isEnabled('app-menu')) {
      toggleMenu()
    }
  });
}

</script>

<style lang="scss" scoped>
.navigation-menu {
  padding: 0 10px;
  position: relative;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ion-color-white);
  border-top: 1px solid var(--ion-color-light-grey);

  &:before {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 100%;
    width: 116px;
    height: 19px;
    margin-left: -58px;
    background: url("/public/assets/images/mask.svg");
  }

  .holder-btn,
  > a {
    display: block;
    flex: 1 1 20%;
  }

  &__navigation-btn {
    margin: 0;
    width: 100%;
    height: calc(60px + var(--ion-safe-area-bottom));
    font-size: 16px;
    line-height: 1;
    --color: var(--ion-color-grey);
    --padding-top: 0;
    --padding-bottom: var(--ion-safe-area-bottom);
    --padding-start: 0;
    --padding-end: 0;
    
    &--main {
      height: calc(54px + var(--ion-safe-area-bottom));
      font-size: 30px;
      margin: -28px 0 0;
      color: var(--ion-color-grey);
    }

  }
}

.active {
  --color: var(--ion-color-primary);
  color: var(--ion-color-primary);
}

.side-menu {
  margin-top: var(--ion-safe-area-top);
  height: calc(100% - 60px - var(--ion-safe-area-top) - var(--ion-safe-area-bottom));

  .header {
    padding: 0 16px;
    box-shadow: none;
    &:after {
      content: '';
      position: absolute;
      z-index: 10;
      left: 16px;
      right: 16px;
      bottom: 0;
      height: 2px;
      width: auto;
      background-color: var(--ion-color-light-grey);
      background-image: none;
    }
  }
}

.sidebar{
  @media screen and (min-width: 1024px) {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 280px;
    padding: 0 40px;
    overflow-y: auto;
    background-image: url(/public/assets/images/sidebar.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
</style>
